import React, { useEffect, useState } from 'react'
import './App.css'
import { Link, Redirect, useHistory, useLocation } from 'react-router-dom'
import Axios from 'axios'
import Footer from './components/Footer'
import { IoIosArrowBack } from 'react-icons/io'
import { RiEditLine } from 'react-icons/ri'
import Header2 from './components/Header2'
import Header3 from './components/Header3'
import Header5 from './components/Header5'
import { CheckUserLogin } from './sessions/CheckUserLoggin'
import { BiMenu } from 'react-icons/bi'
import Header from './layouts/Header'
import SideNav from './layouts/SideNav'
import SideNavCust from './layouts/SideNavCust'
import SideNavAff from './layouts/SideNavAff'
import { API_URL } from './config'

const BankDetails = () => {
  CheckUserLogin()
  const location = useLocation()
  const history = useHistory()

  const { responseMessage, responseCode, bankList } = location.state || {}
  const [bankName, setBankName] = React.useState('N/A')
  const [branchCode, setBranchCode] = React.useState('N/A')
  const [accountNumber, setAccountNumber] = React.useState('N/A')
  const [accountName, setAccountName] = React.useState('N/A')
  const [accountType, setAccountType] = React.useState('N/A')
  const [accountHolder, setAccountHolder] = React.useState('N/A')
  const [createdAt, setCreatedAt] = React.useState('N/A')
  const [message, setMessage] = React.useState('N/A')
  const [error, setError] = React.useState(false)

  const isMobile = window.innerWidth <= 768
  const [isMob, setIsMob] = useState()
  const [collapsed, setCollapsed] = useState(isMobile)
  const accounttype = localStorage.getItem('accounttype')

  const updateIsMobile = () => {
    const mobile = window.innerWidth <= 768
    setIsMob(mobile)
    setCollapsed((prev) => (mobile ? true : prev))
  }

  useEffect(() => {
    const businessname = localStorage.getItem('businessname')
    const businessid = localStorage.getItem('businessid')
    document.title = 'Bank details'

    Axios.get(`${API_URL}/apps/kscanner/webservices.php?query=RETRIEVEBANKDETAILS`, {
      withCredentials: true,
    })
      .then((response) => {
        const data = response.data
        if (data.status === 'failed') {
          setMessage(data.message)
          setError(true)
          console.log('Error: ', data.message)
          return
        }
        const bank_name = data.bank_label.replace('_', ' ')
        if (accounttype === 'customer') {
          setBankName(
            bank_name
              .split(' ')
              .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
              .join(' ') ?? 'N/A'
          )
        } else {
          setBankName(data.bank_name)
        }
        setBranchCode(data.branch_code ?? 'N/A')
        setAccountNumber(data.account_number ?? 'N/A')
        setAccountHolder(data.account_holder ?? 'N/A')
        setAccountName(data.account_name ?? 'N/A')
        setAccountType(data.account_type ?? 'N/A')
        setCreatedAt(data.created_at)
      })
      .catch(function (error) {
        console.log('Error: ', error)
      })

    updateIsMobile()
    window.addEventListener('resize', updateIsMobile)

    return () => {
      // this runs on unmount
      window.removeEventListener('resize', updateIsMobile)
    }
  }, [])

  const handleToggle = () => {
    setCollapsed((prev) => !prev)
  }

  return (
    <div className="view">
      <Header />
      {accounttype === 'customer' ? (
        <>
          <SideNavCust collapsed={collapsed} onToggle={handleToggle} />
        </>
      ) : accounttype === 'business' ? (
        <>
          <SideNav collapsed={collapsed} onToggle={handleToggle} />
        </>
      ) : (
        <SideNavAff collapsed={collapsed} onToggle={handleToggle} />
      )}

      <div
        className="container"
        style={{
          marginTop: 40,
          marginLeft: isMob ? '0px' : collapsed ? 'auto' : 'auto',
        }}
      >
        {/* ✅ Mobile overlay when sidebar is open */}
        {isMobile && !collapsed && <div className="mobile-overlay active" onClick={handleToggle} />}

        {isMob && collapsed && (
          <label className="mobile-toggle" onClick={handleToggle}>
            <BiMenu size={25} />
          </label>
        )}
        <div className="row justify-content-center just-container-insid">
          <div className="col-lg-7 pl-0 pr-0">
            <div className=" BoxDashboardContainer mt-5 mb-4 mrgin-search pl-0 pr-0">
              <div className="row align-self-center justify-content-center">
                <div className="item-list p-0">
                  <div className="col-lg-4 col-6 pl-0">
                    <button type="button" onClick={() => history.goBack()} className="link-btn">
                      <IoIosArrowBack size={25} />
                      Back &nbsp;
                    </button>
                  </div>

                  <div className="col-lg-8 col-6 text-right p-0">
                    <label className="back-arrow mb-0">
                      <Link
                        to={{
                          pathname: 'edit-b-details',
                          state: {
                            accountHolder: accountHolder,
                            accountName: accountName,
                            accountNumber: accountNumber,
                            accountType: accountType,
                            branchCode: branchCode,
                            bankName: bankName,
                            responseCode: responseCode ?? '',
                            bankList: bankList ?? [],
                          },
                        }}
                        className="link-btn"
                      >
                        <div className="edit-btn">
                          {responseMessage && responseCode === 'BANK_DETAILS_MISSING'
                            ? '+ Add'
                            : 'Edit'}
                        </div>
                      </Link>
                    </label>
                  </div>
                </div>
              </div>
            </div>

            <div className=" BoxDashboardContainer pl-0 pr-0">
              <div className="row align-self-center justify-content-center">
                <div className="item-list p-0">
                  <div className="col-lg-12 pl-0 pr-0">
                    <label className="ticket-title pl-0 pr-0 w-100">BANK DETAILS</label>
                  </div>
                </div>
                <div className="item-list p-0">
                  {error && responseCode !== 'BANK_DETAILS_MISSING' ? (
                    <div
                      className="col-lg-12 text-left alert alert-info"
                      style={{ borderRadius: 10 }}
                    >
                      <label className=" mb-0 w-100">
                        {message}
                        <Link
                          to={{
                            pathname: 'edit-b-details',
                            state: {
                              accountHolder: accountHolder,
                              accountName: accountName,
                              accountNumber: accountNumber,
                              accountType: accountType,
                              branchCode: branchCode,
                              bankName: bankName,
                            },
                          }}
                          className="color-blue float-right cursor-pointer"
                        >
                          + Add
                        </Link>
                      </label>
                    </div>
                  ) : (
                    <div className="col-lg-12 text-left p-0">
                      <label className="alert alert-warning p-2 mb-0 w-100">
                        <span>Important:</span>
                        <br />
                        {responseMessage && responseCode === 'BANK_DETAILS_MISSING' ? (
                          <>{responseMessage}</>
                        ) : (
                          'Please ensure that your banking details are correct to avoid any issues with payouts.'
                        )}
                      </label>
                    </div>
                  )}
                </div>

                <div className="h-divider w-100"></div>
              </div>
              <div className="col-lg-12 details-body">
                Bank name
                <br />
                <label className="small-details">{bankName}</label>
                <br /> <br />
                Account holder
                <br />
                <label className="small-details">{accountHolder}</label>
                <br /> <br />
                Account number
                <br />
                <label className="small-details">{accountNumber}</label>
                <br />
                <br />
                Account type
                <br />
                <label className="small-details">{accountType}</label>
                <br />
                <br />
                Branch code
                <br />
                <label className="small-details">{branchCode}</label>
                <br />
                <br />
                Details created on
                <br />
                <label className="small-details">{createdAt ? createdAt : 'N/A'}</label>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* <Footer /> */}
    </div>
  )
}

export default BankDetails
